// extracted by mini-css-extract-plugin
export default {"popin":"En97Z","connectionSection":"MrY0e","title1":"QGGz5","title2":"KTMCC","onCloseButton":"quH5P","list":"PMlkc","incentiveIllustration":"h5JvH"};